import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: "公司信息",
      visible: _vm.innerVisible,
      "before-close": _vm.onBeforeClose,
      "close-on-click-modal": false,
      width: "850px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.innerVisible = $event;
      }
    }
  }, [_c("div", [_c("el-form", {
    ref: "form",
    attrs: {
      size: "small",
      model: _vm.localForm,
      "label-width": "110px",
      rules: _vm.addRules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "公司名称",
      prop: "companyName"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.localForm.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "companyName", $$v);
      },
      expression: "localForm.companyName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "认证类型",
      prop: "certificationType"
    }
  }, [_c("el-select", {
    model: {
      value: _vm.localForm.certificationType,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "certificationType", $$v);
      },
      expression: "localForm.certificationType"
    }
  }, [_c("el-option", {
    attrs: {
      label: "营业执照",
      value: "company"
    }
  }), _c("el-option", {
    attrs: {
      label: "身份证",
      value: "personal"
    }
  })], 1)], 1), _vm.localForm.certificationType == "company" ? _c("el-form-item", {
    attrs: {
      label: "认证名称",
      prop: "certificationName"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.localForm.certificationName,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "certificationName", $$v);
      },
      expression: "localForm.certificationName"
    }
  })], 1) : _vm._e(), _vm.localForm.certificationType == "company" ? _c("el-form-item", {
    attrs: {
      label: "信用代码",
      prop: "authNo"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.localForm.authNo,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "authNo", $$v);
      },
      expression: "localForm.authNo"
    }
  })], 1) : _vm._e(), _vm.localForm.certificationType == "personal" ? _c("el-form-item", {
    attrs: {
      label: "身份证号",
      prop: "authNo"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.localForm.authNo,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "authNo", $$v);
      },
      expression: "localForm.authNo"
    }
  })], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: _vm.localForm.certificationType == "company" ? "营业执照" : "身份证"
    }
  }, [_c("el-upload", {
    ref: "uploader",
    attrs: {
      action: _vm.apiBaseUrl + "/api/v3/utils/uploadFile",
      "file-list": _vm.localFileList,
      "list-type": "picture-card",
      "on-success": _vm.uploadSuccess,
      "on-change": _vm.uploadChange,
      "auto-upload": true,
      drag: ""
    },
    scopedSlots: _vm._u([{
      key: "file",
      fn: function fn(_ref) {
        var file = _ref.file;
        return _c("div", {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: file.loading,
            expression: "file.loading"
          }],
          staticClass: "upload-item-wrap",
          attrs: {
            "element-loading-text": "图片上传中...",
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "rgba(0, 0, 0, 0.8)"
          }
        }, [_c("el-image", {
          attrs: {
            src: file.url,
            fit: "cover"
          }
        }, [_c("div", {
          staticClass: "image-slot",
          attrs: {
            slot: "placeholder"
          },
          slot: "placeholder"
        }, [_vm._v("加载中"), _c("span", {
          staticClass: "dot"
        }, [_vm._v("...")])])]), _c("span", {
          staticClass: "el-upload-list__item-actions"
        }, [_c("span", {
          staticClass: "el-upload-list__item-preview",
          on: {
            click: function click($event) {
              return _vm.handlePictureCardPreview(file);
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-zoom-in"
        })]), _c("span", {
          staticClass: "el-upload-list__item-delete",
          on: {
            click: function click($event) {
              return _vm.handleRemove(file);
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-delete"
        })])])], 1);
      }
    }])
  }, [_c("i", {
    staticClass: "el-icon-plus",
    attrs: {
      slot: "default"
    },
    slot: "default"
  })])], 1), _c("el-form-item", {
    attrs: {
      label: "城市",
      prop: "city"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: ""
    },
    model: {
      value: _vm.localForm.city,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "city", $$v);
      },
      expression: "localForm.city"
    }
  }, _vm._l(_vm.cityList, function (item) {
    return _c("el-option", {
      key: item.token,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "对接人",
      prop: "counterpart"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.localForm.counterpart,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "counterpart", $$v);
      },
      expression: "localForm.counterpart"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "对接人手机号",
      prop: "counterpartPhone"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.localForm.counterpartPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "counterpartPhone", $$v);
      },
      expression: "localForm.counterpartPhone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "负责人",
      prop: "personCharge"
    }
  }, [_c("el-select", {
    model: {
      value: _vm.localForm.personCharge,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "personCharge", $$v);
      },
      expression: "localForm.personCharge"
    }
  }, _vm._l(_vm.adminList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "类型标签"
    }
  }, [_c("el-checkbox-group", {
    model: {
      value: _vm.localTypeTagsVal,
      callback: function callback($$v) {
        _vm.localTypeTagsVal = $$v;
      },
      expression: "localTypeTagsVal"
    }
  }, _vm._l(_vm.typeTags, function (tag) {
    return _c("el-checkbox", {
      key: tag.id,
      attrs: {
        size: "small",
        label: tag.id,
        border: ""
      }
    }, [_vm._v(_vm._s(tag.ch))]);
  }), 1)], 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.onCancel
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.disSubmit
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v("确 定")])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };